const website = require("./website")

module.exports = {
  "en-gb": {
    default: true,
    path: "en",
    locale: "en-gb",
    siteLanguage: "en",
    ogLang: "en_US",
    langName: "English",
    defaultTitle: website.title,
    defaultTitleAlt: website.titleAlt,
    defaultDescription: website.description,
    headline: website.headline,
    gdprMessage: website.gdprMessage,
    gdprAccept: "Accept",
    gdprDecline: "Decline",
  },
  "fr-fr": {
    default: false,
    path: "fr",
    locale: "fr-fr",
    langName: "Français",
    siteLanguage: "fr",
    ogLang: "fr_FR",
    defaultTitle: website.title,
    defaultTitleAlt: website.titleAlt,
    defaultDescription: "Monstock - Gérez vos stocks en toute mobilité",
    headline: website.headline,
    gdprMessage: "Pouvons-nous utiliser des cookies?",
    gdprAccept: "Accepter",
    gdprDecline: "Refuser",
  },
}
